import React, { useState } from 'react';
import { SheetMusicBrowseCommon } from './../browse/SheetMusicBrowseCommon';
import { Header, Divider, Icon } from 'semantic-ui-react'

export function SongSheetMusic(props) {
	const [childRendering, setChildRendering] = useState(true);
	return (
		<>
			{childRendering &&
				<>
					<Divider horizontal inverted>
						<Header as='h4' inverted>
							<Icon name='file alternate outline' />
							Sheet Music
						</Header>
					</Divider>
					<SheetMusicBrowseCommon slim={true} song={props.song}
						urlParams={false} relatedRendered={(val) => setChildRendering(val)}/>
				</>
			}
		</>
	);
}